import { Component, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute,Router } from "@angular/router";
import { ToastService } from "angular-toastify";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { WorkOrderService } from "@services/workOrder.service";
import { WorkOrderCreationDetailsDto } from "@interfaces/workOrderCreationDetailsDto.interface";
import { CalculatedWorkOrder } from "@interfaces/calculatedWorkOrder.interface";

@Component({
	encapsulation: ViewEncapsulation.None,
	moduleId: module.id,
	selector: "salesOrderParts-id-createWorkOrders",
	styleUrls: ["salesOrderParts-id-createWorkOrders.css"],
	templateUrl: "salesOrderParts-id-createWorkOrders.html"
})
export class SalesOrdersPartsIdCreateWorkOrdersAdminComponent {
	calculatedWorkOrders: CalculatedWorkOrder[] = [];
	editRowKey: any = null;
	headerPrimaryButtons: AdminHeaderButton[] = [
		{ method: "createWorkOrders", text: "Create Work Orders" },
		{ method: "cancelCreation", text: "Return to Sales Order" }
	];
	item: WorkOrderCreationDetailsDto = new WorkOrderCreationDetailsDto();
	saveEnabled = true;
	title = "Create Work Orders";

	constructor(private router: Router, private toastService: ToastService, private route: ActivatedRoute, private workOrderService: WorkOrderService) {
		this.route.params.subscribe((params) => {
			this.getWorkOrderDetails(params.id);
		});

		this.checkLinkedQuantities = this.checkLinkedQuantities.bind(this);
		this.lockSaveButton = this.lockSaveButton.bind(this);
		this.unlockSaveButton = this.unlockSaveButton.bind(this);
	}

	cancelCreation() {
		if (confirm("Are you sure you wish to return to the sales order without creating work orders?") == false) {
			return;
		}
		this.returnToSalesOrder();
	}

	checkLinkedQuantities(e: any) {
		if (e.oldData.linkedPartGroupId !== null && e.oldData.linkedPartGroupId !== undefined && e.oldData.linkedPartGroupId > 0) {
			if (e.newData.workOrderQuantity % e.oldData.linkedProportion > 0) {
				alert("Invalid quantity for linked part - the proportions must match the group info.");
				e.cancel = true;
				return;
			}

			const baseQuantityForGroup = e.newData.workOrderQuantity / e.oldData.linkedProportion;
			this.calculatedWorkOrders
				.filter((c: CalculatedWorkOrder) => c.linkedPartGroupId === e.oldData.linkedPartGroupId && c.partId !== e.oldData.partId)
				.forEach((line) => {
					line.workOrderQuantity = line.linkedProportion === undefined ? baseQuantityForGroup : baseQuantityForGroup * line.linkedProportion;
				});
		}

		this.saveEnabled = true;
	}

	childDepth(cellInfo: any) {
		if (cellInfo.value > 0) {
			const text = ">";
			return text.repeat(cellInfo.value);
		}
		else {
			return "";
		}
	}

	createWorkOrders() {
		if (this.saveEnabled === false) {
			return;
		}
		if (confirm("Are you sure you the below details are correct? Once the work orders have been created you will be returned to the sales order.") == false) {
			return;
		}
		this.item.workOrderLineItems = JSON.stringify(this.calculatedWorkOrders);
		this.workOrderService.createForSalesOrderPart(this.item)
			.subscribe(
				() => {
					this.toastService.success("Work orders Created.");
					this.returnToSalesOrder();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	getWorkOrderDetails(id: number) {
		this.workOrderService.calculateForSalesOrderPart(id)
			.subscribe(
				(res: any) => {
					this.item = res.response;
					this.calculatedWorkOrders = JSON.parse(this.item.workOrderLineItems);
					this.title = "Create Work Orders for Sales Order " + this.item.salesOrderId;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	lockSaveButton() {
		this.saveEnabled = false;
	}

	returnToSalesOrder() {
		this.router.navigate([`admin/salesOrders/${this.item.salesOrderLookupId}`]);
	}

	unlockSaveButton() {
		this.saveEnabled = true;
	}
}